import './styles.css';
import '../../fonts.css';

import { Link } from 'react-router-dom';
import { IoChevronBackOutline } from 'react-icons/io5';

const Layout = (props) => {
  const {
    title,
    titleColor,
    description,
    children,
    button,
    backButton,
    hasBackground = true
  } = props;

  const renderButton = () => {
    if (button) {
      const { text, icon, router, clickHandle } = button;

      return (
        <div className="bottom-button-container">
          {router ? <Link
            to={router}
            onClick={clickHandle}
          >
            <div className="bottom-button">
              {icon}
              <p>{text}</p>
            </div>
          </Link> :
            <div className="bottom-button" onClick={clickHandle}>
              {icon}
              <p>{text}</p>
            </div>
          }
        </div>
      );
    }
  }

  const renderBackButton = () => {
    if (backButton && typeof backButton === "string") {
      return <Link to={backButton} style={{ textDecoration: 'none' }}>
        <div className="back-button"><IoChevronBackOutline className="button-svg"/></div>
      </Link>;
    }
  }

  return <div className="header-container">
    {renderBackButton()}
    <div className="header-title" style={{ color: titleColor }}>{title}</div>
    <div className="header-description">{description}</div>
    <div className={`${hasBackground ? "white-box" : "" }`}>
      {children}
    </div>
    {renderButton()}
  </div>
}

export default Layout;